export const PATIENT_MEDICAL_INFORMATION_REMOVE_REASON_ITEMS = ['MISTAKE', 'OTHER'] as const;
